import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { switchMap, catchError } from 'rxjs/operators';
import { AuthenticationResult, SilentRequest } from '@azure/msal-browser';
import { environment } from '@environments/environment';
import { throwError } from 'rxjs';
import {protectedResources} from './scopes';

@Injectable()
export class DynamicScopeInterceptor implements HttpInterceptor {

  constructor(private authService: MsalService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const account = this.authService.instance.getActiveAccount() || this.authService.instance.getAllAccounts()[0];
    //console.log("intercept", req.url)
    if (!account) {
      console.error('No hay cuenta activa, omitiendo la autenticación.');
      return next.handle(req); // Si no hay cuenta, continúa sin token.
    }
    /*const scope = this.getScopesByUserProfile(account);
    console.log("account", account);
    var json = localStorage.getItem("rolUserLocalStorage");
    console.log("rolUserLocalStorage", json);*/
    //console.log("urlRequest", req.url)

    const scopes = this.getScopesByUserProfile(account, req.url);

    //console.log("result", req.url, scopes);

   /* var scope1 = `${environment.api.id}/api-access`;
    if(req.url.indexOf(environment.api.baseUpload) != -1){
      scope1 = `${environment.api.idEzshare}/Access-ezshared`;
    } 

    if(req.method == 'delete'){
      scope1 = `${environment.api.id}/Luca.Admin`;
    };*/
    
    const tokenRequest: SilentRequest = {
      scopes: scopes, 
      account
    };

    return from(this.authService.instance.acquireTokenSilent(tokenRequest)).pipe(
      switchMap((tokenResponse: AuthenticationResult) => {
        //console.log("tokenResponse", tokenResponse);
        const clonedReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${tokenResponse.accessToken}`,
            "Ocp-Apim-Subscription-Key": environment.api.subscriptionKey,
            "Strict-Transport-Security": "max-age=7200"
          }
        });
        return next.handle(clonedReq);
      }),
      catchError(error => {
        console.error('Error obteniendo el token:', error);
        return throwError(() => error); // Lanza el error para que Angular lo maneje.
      })
    );
  }

  private getScopesByUserProfile(account: any, urlRequest: string): string[] {
    const userGroups = account.idTokenClaims?.groups || [];
 
    const scope = this.findScopesForUrl(urlRequest);
    if(scope.includes(environment.api.adminScope) && !userGroups.includes(environment.api.adminRole)){
      return []; // no acccess
    }
 
    return scope;
  }

  private findScopesForUrl(urlRequest: string): string[] {
    
    for (const [pattern, scopesRaw] of protectedResources) {
 
      const regexPattern = '^' + pattern.toString().replace(/[.+?^${}()|[\]\\]/g, '\\$&').replace(/\\/g, '.*'); 
      const regex = new RegExp(regexPattern);

      if (regex.test(urlRequest)) {
        const scopes: string[] = Array.isArray(scopesRaw) ? scopesRaw: [scopesRaw as string];
        return scopes;
      }
    }
    return [`${environment.api.id}/api-access`];
  }
}
